import React, { lazy, Suspense, useContext } from "react";
import { createBrowserRouter, Navigate, useLocation } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
const Layout = lazy(() => import("../layouts/index"));
const Home = lazy(() => import("../pages/home"));
const Mission = lazy(() => import("../pages/mission/mission"));
const Objectives = lazy(() => import("../pages/objectives/objectives"));
const Values = lazy(() => import("../pages/values/values"));
const Founders = lazy(() => import("../pages/founders/founder"));
const Contact = lazy(() => import("../pages/contact/contact"));
const OnlineChat = lazy(() => import("../pages/onlinechat/online"));
const Roomrental = lazy(() => import("../pages/roomrental/index"));
const PaymentModal = lazy(() => import("../pages/roomrental/PaymentModal/payment"));
const ChatDetail = lazy(() =>
  import("../pages/onlinechat/chatdetail/chatdetail")
);
const Services = lazy(() => import("../pages/services/services"));
const ServicesDetail = lazy(() =>
  import("../pages/services/servicesdetail/detail")
);
const Team = lazy(() => import("../pages/team/team"));
const NotFound = lazy(() => import("../pages/404"));
const Psychologist = lazy(() =>
  import("../pages/team/psychologist/psychologist")
);
const Login = lazy(() => import("../pages/registration/login"));
const Register = lazy(() => import("../pages/registration/register"));
const Profile = lazy(() => import("../pages/profile/profile"));
const SupportVideos = lazy(() =>
  import("../pages/profile/profile_content/supportvideo")
);
const Trainings = lazy(() =>
  import("../pages/profile/profile_content/trainings")
);
const Video = lazy(() => import("../pages/profile/profile_content/video"));
const FooterPrivacy = lazy(() =>
  import("../layouts/footer/footerPrivacy/footer_privacy")
);

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated } = useContext(AuthContext);

  if (!isAuthenticated) {
    return <Navigate to="/registration" />;
  }

  return children;
};

export const router = createBrowserRouter([
  {
    path: "/",
    element: <Layout />,
    children: [
      {
        path: "/",
        element: <Home />,
      },
      {
        path: "/contact",
        element: <Contact />,
      },
      {
        path: "/onlinechat",
        element: <OnlineChat />,
      },
      {
        path: "/chatdetail",
        element: <ChatDetail />,
      },
      {
        path: "/xidmətlərimiz",
        element: <Services />,
      },
      {
        path: "/roomrental",
        element: <Roomrental />,
      },
      {
        path: "/payment",
        element: <PaymentModal />,
      },
      {
        path: "/servicesdetail/:id",
        element: <ServicesDetail />,
      },
      {
        path: "/komandamız",
        element: (
          <ProtectedRoute>
            <Team />
          </ProtectedRoute>
        ),
      },
      {
        path: "/not-found",
        element: <NotFound />,
      },
      {
        path: "*",
        element: <NotFound />,
      },
      {
        path: "/privacy-policy",
        element: <FooterPrivacy />,
      },
      {
        path: "/missiyamız",
        element: <Mission />,
      },
      {
        path: "/founders",
        element: <Founders />,
      },
      {
        path: "/objectives",
        element: <Objectives />,
      },
      {
        path: "/values",
        element: <Values />,
      },
      {
        path: "/psychologist/:id",
        element: <Psychologist />,
      },
      {
        path: "/login",
        element: <Login />,
      },
      {
        path: "/registration",
        element: <Register />,
      },
      {
        path: "/profile",
        element: (
          <ProtectedRoute>
            <Profile />
          </ProtectedRoute>
        ),
      },
      {
        path: "/supportvideos",
        element: (
          <ProtectedRoute>
            <SupportVideos />
          </ProtectedRoute>
        ),
      },
      {
        path: "/trainings",
        element: (
          <ProtectedRoute>
            <Trainings />
          </ProtectedRoute>
        ),
      },
      {
        path: "/video",
        element: (
          <ProtectedRoute>
            <Video />
          </ProtectedRoute>
        ),
      },
    ],
  },
]);
